// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Oth {
  font-size: 14px !important;
  /* font-weight: 500 !important; */
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  padding: 14px 5px 14px 20px !important;
  text-align: left;
}

.Otd {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  padding: 14px 5px 14px 20px !important;
  text-align: left;
}

.Otdd {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  width: 20px !important;
  border-bottom: 1px solid #efefef !important;
  padding: 14px 5px 14px 20px !important;
  text-align: left;
}

.orderT {
  border-collapse: collapse;
  width: 99%;
  margin: 1%;
  margin-top: 1%;
}

.orderTT {
  border-collapse: collapse;
  width: 99%;
  margin-right: 1%;
  margin-bottom: 1%;
  margin-top: 2%;
}

/* .noOrders {
  color: red;
} */

.dropdownO {
  padding: 5px;
  margin-top: -28px;
  border: 1px solid #ccc;
  /* margin-left: 330px; */
  /* margin-right: 17px; */
  border-radius: 5px;
  width: 157px;
  height: 37px;
  cursor: pointer;
  font-size: 14px;
}

.searchbarrs {
  border: 1px solid #ccc;
  height: 37px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  margin-top: -5px;
  width: 170px;
  padding: 0 10px;
  margin-left: 65%;
}

.uploadSS {
  align-items: center;
  margin-right: 23px;
  /* margin-left: 10px; */
  margin-top: 0.4%;
  border-radius: 50px;
}

.choose-file-buttonn {
  background-image: linear-gradient(to top, rgb(227, 226, 226), white);
  border: 1px solid lightgray;
  border-radius: 6px;
  margin-top: -14px;
  height: 40px;
}

.boxeS {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px; /* Set a max-width to limit the width on large screens */
  padding: 0 0px; /* Add padding to provide spacing on smaller screens */
}
.headingz {
  margin-top: 5%;
}

.bx3 tbody tr:last-of-type td {
  font-weight: 600;
  font-size: 16px;
  color: #07a6ef;
}

@media (max-width: 768px) {
  .boxesS {
    flex-direction: column; /* Stack items vertically on smaller screens */
    margin-top: 10px; /* Adjust top margin */
    padding: 0 10px; /* Reduce padding on smaller screens */
    /* display: ruby; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/OrderExcel.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,iBAAiB;EACjB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oEAAoE;EACpE,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB,EAAE,wDAAwD;EAC3E,cAAc,EAAE,sDAAsD;AACxE;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB,EAAE,8CAA8C;IACtE,gBAAgB,EAAE,sBAAsB;IACxC,eAAe,EAAE,sCAAsC;IACvD,mBAAmB;EACrB;AACF","sourcesContent":[".Oth {\r\n  font-size: 14px !important;\r\n  /* font-weight: 500 !important; */\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 14px 5px 14px 20px !important;\r\n  text-align: left;\r\n}\r\n\r\n.Otd {\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 14px 5px 14px 20px !important;\r\n  text-align: left;\r\n}\r\n\r\n.Otdd {\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  width: 20px !important;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 14px 5px 14px 20px !important;\r\n  text-align: left;\r\n}\r\n\r\n.orderT {\r\n  border-collapse: collapse;\r\n  width: 99%;\r\n  margin: 1%;\r\n  margin-top: 1%;\r\n}\r\n\r\n.orderTT {\r\n  border-collapse: collapse;\r\n  width: 99%;\r\n  margin-right: 1%;\r\n  margin-bottom: 1%;\r\n  margin-top: 2%;\r\n}\r\n\r\n/* .noOrders {\r\n  color: red;\r\n} */\r\n\r\n.dropdownO {\r\n  padding: 5px;\r\n  margin-top: -28px;\r\n  border: 1px solid #ccc;\r\n  /* margin-left: 330px; */\r\n  /* margin-right: 17px; */\r\n  border-radius: 5px;\r\n  width: 157px;\r\n  height: 37px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n.searchbarrs {\r\n  border: 1px solid #ccc;\r\n  height: 37px;\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  margin-top: -5px;\r\n  width: 170px;\r\n  padding: 0 10px;\r\n  margin-left: 65%;\r\n}\r\n\r\n.uploadSS {\r\n  align-items: center;\r\n  margin-right: 23px;\r\n  /* margin-left: 10px; */\r\n  margin-top: 0.4%;\r\n  border-radius: 50px;\r\n}\r\n\r\n.choose-file-buttonn {\r\n  background-image: linear-gradient(to top, rgb(227, 226, 226), white);\r\n  border: 1px solid lightgray;\r\n  border-radius: 6px;\r\n  margin-top: -14px;\r\n  height: 40px;\r\n}\r\n\r\n.boxeS {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-top: 20px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  max-width: 1200px; /* Set a max-width to limit the width on large screens */\r\n  padding: 0 0px; /* Add padding to provide spacing on smaller screens */\r\n}\r\n.headingz {\r\n  margin-top: 5%;\r\n}\r\n\r\n.bx3 tbody tr:last-of-type td {\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  color: #07a6ef;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .boxesS {\r\n    flex-direction: column; /* Stack items vertically on smaller screens */\r\n    margin-top: 10px; /* Adjust top margin */\r\n    padding: 0 10px; /* Reduce padding on smaller screens */\r\n    /* display: ruby; */\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
